export function formatDate(dateStr: string, type: string = 'short'): string {
  const newDate = new Date(dateStr)
  // @ts-ignore
  return new Intl.DateTimeFormat('en-GB', { dateStyle: type }).format(newDate)
}

const gbpFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
})

export function formatGBP(amount: number): string {
  return gbpFormatter.format(amount)
}

export function isDateTimeOffsetDefaultDate(stringDate?: string) {
  return stringDate === undefined || stringDate === '0001-01-01T00:00:00'
}

export function capitalize(str?: string) {
  if (!str || str.trim() === '') return ''
  return str
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
    .trim()
}

export function encodeUrlParameters(params: string) {
  return btoa(params)
}

export function decodeUrlParameters(params: string) {
  return atob(params)
}

export const camelCaseToReadable = (str: string) => str.split(/(?=[A-Z])/).join(' ')

export const toLabel = (data?: string, defaultLabel = 'No data') =>
  data && data !== '' ? data : defaultLabel

export const safelyOpenLink = (link: string) => {
  const redirect = window.open(link, '_blank', 'noopener, noreferrer')

  if (redirect) {
    redirect.opener = null
  }
}
